(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  const SEL = '.product-media__image';
  // Horizon scrolls inside .page-wrapper, not the window.
  const root = document.querySelector('.page-wrapper') || null;

  const reveal = (img) => {
    if (img.dataset.petovaReveal) return;
    img.dataset.petovaReveal = '1';
    img.classList.add('petova-reveal');

    const show = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => img.classList.add('is-inview'));
      });
    };

    if (img.complete && img.naturalWidth > 0) {
      show();
    } else {
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', () => img.classList.add('is-inview'), { once: true });
    }
  };

  const io = new IntersectionObserver(
    (entries) => {
      const scrollTop = root ? root.scrollTop : (window.scrollY || 0);
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const img = entry.target;
        // Keep first-paint LCP images quiet.
        const aboveFoldEager =
          img.getAttribute('loading') !== 'lazy' &&
          scrollTop < 40 &&
          entry.boundingClientRect.top < window.innerHeight * 0.9;
        if (aboveFoldEager) {
          io.unobserve(img);
          continue;
        }
        reveal(img);
        io.unobserve(img);
      }
    },
    { root, rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
  );

  const watch = (doc = document) => {
    doc.querySelectorAll(SEL).forEach((img) => {
      if (!img.dataset.petovaReveal) io.observe(img);
    });
  };

  const start = () => {
    watch();
    if (document.body) {
      new MutationObserver(() => watch()).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
